import { LimeCollapse } from "@/Components/NextBase/LimeCollapse";

/** Spacing lives inside each block: a parent gap would snap in as a hidden block mounts. */
export function Section({
  children,
  spacing = "pb-4",
}: {
  children: React.ReactNode;
  spacing?: string;
}) {
  return <div className={spacing}>{children}</div>;
}

/** A block that shows and hides, animated open and closed. */
export function Reveal({
  isOpen,
  children,
  spacing = "pb-4",
}: {
  isOpen: boolean;
  children: React.ReactNode;
  spacing?: string;
}) {
  return (
    <LimeCollapse isOpen={isOpen} className="overflow-hidden">
      <div className={spacing}>{children}</div>
    </LimeCollapse>
  );
}
